import { IDeleteSaidaPUseCase } from "../../../presentation/useCases/delete/delete_saida_produtos_use_case";
import { IEstoqueRepository } from "../../repositories/estoque_repository";

export class DeleteSaidaPUseCase implements IDeleteSaidaPUseCase {
  constructor(private readonly repository: IEstoqueRepository) {}

  async deleteSaidaP(IdSaidaProduto: number): Promise<void> {
    
    await this.repository.deleteSaidaP(IdSaidaProduto);
  }
}
